import { Box, SpaceBetween } from '@cloudscape-design/components';
import { ConfigurationObject } from '../../services/configs-api';

interface BusinessHoursDetailProps {
  config: ConfigurationObject;
}

type DayName = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

const DAYS: { key: DayName; label: string }[] = [
  { key: 'monday', label: 'Mon' },
  { key: 'tuesday', label: 'Tue' },
  { key: 'wednesday', label: 'Wed' },
  { key: 'thursday', label: 'Thu' },
  { key: 'friday', label: 'Fri' },
  { key: 'saturday', label: 'Sat' },
  { key: 'sunday', label: 'Sun' },
];

/**
 * Human-readable detail view for Business Hours config type.
 * Shows: Timezone, compact weekly schedule grid (Mon 08:00–17:00, etc.)
 */
export function BusinessHoursDetail({ config }: BusinessHoursDetailProps) {
  const payload = config.payload ?? {};
  const timezone = (payload.timeZone as string) ?? '—';

  return (
    <SpaceBetween size="m">
      <div>
        <Box variant="awsui-key-label">Timezone</Box>
        <div>{timezone}</div>
      </div>

      <div>
        <Box variant="awsui-key-label">Weekly Schedule</Box>
        <div style={{ display: 'grid', gridTemplateColumns: '50px 1fr', gap: '4px 12px', marginTop: '4px' }}>
          {DAYS.map(({ key, label }) => {
            const enabled = payload[`${key}_enabled`] === true || payload[`${key}_enabled`] === 'true';
            const start = (payload[`${key}_startTime`] as string) ?? '';
            const end = (payload[`${key}_endTime`] as string) ?? '';

            return (
              <div key={key} style={{ display: 'contents' }}>
                <strong>{label}</strong>
                <span style={{ color: enabled ? '#16191F' : '#687078' }}>
                  {enabled && start && end ? `${start}–${end}` : '—'}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </SpaceBetween>
  );
}
